<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    id="qiscus-sdk-sprite"
  >
    <symbol
      id="ic-empty-state"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M21 11.5C21.0034 12.8199 20.6951 14.1219 20.1 15.3C19.3944 16.7118 18.3098 17.8992 16.9674 18.7293C15.6251 19.5594 14.0782 19.9994 12.5 20C11.1801 20.0035 9.87812 19.6951 8.7 19.1L3 21L4.9 15.3C4.30493 14.1219 3.99656 12.8199 4 11.5C4.00061 9.92179 4.44061 8.37488 5.27072 7.03258C6.10083 5.69028 7.28825 4.6056 8.7 3.90003C9.87812 3.30496 11.1801 2.99659 12.5 3.00003H13C15.0843 3.11502 17.053 3.99479 18.5291 5.47089C20.0052 6.94699 20.885 8.91568 21 11V11.5Z"
        stroke="#A0A0A0"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </symbol>
    <symbol id="ic-attachment" viewBox="0 0 39 48">
      <use xlink:href="#a1" />
      <defs>
        <path
          id="a1"
          d="M20 18.2l-9.2 14.5c-.8 1.1-.4 2.8.7 3.5 1.2.8 2.8.4 3.6-.7L24.3 21c.5-.8 1.5-1 2.3-.5.8.5 1 1.6.5 2.3L16.1 40a6 6 0 0 1-8.2 2A6 6 0 0 1 6 33.7L22.6 7.9A6 6 0 0 1 31 6a6 6 0 0 1 1.8 8.2c-.9 1.2-.5 2.8.8 3.6 1.1.7 2.7.3 3.5-.8A11.1 11.1 0 0 0 18.3 5L1.7 30.9a11.1 11.1 0 0 0 18.8 12l11.2-17.5a7 7 0 0 0-2.2-9.2 6.8 6.8 0 0 0-9.4 2z"
        />
      </defs>
    </symbol>
    <symbol id="ic-close" viewBox="0 0 20 20">
      <path
        id="path0_fill"
        d="M 19.6022 19.6022C 20.1326 19.072 20.1326 18.212 19.6022 17.6819L 11.9204 9.99988L 19.6023 2.31818C 20.1326 1.78773 20.1326 0.928053 19.6023 0.397595C 19.072 -0.132532 18.2121 -0.132532 17.6818 0.397595L 10 8.07962L 2.31819 0.397595C 1.78788 -0.132532 0.928042 -0.132532 0.397732 0.397595C -0.132577 0.928053 -0.132577 1.78773 0.397732 2.31818L 8.07957 9.99988L 0.397753 17.6819C -0.132557 18.212 -0.132557 19.072 0.397753 19.6022C 0.928063 20.1326 1.78788 20.1326 2.31821 19.6022L 10 11.9205L 17.6818 19.6022C 18.2121 20.1326 19.0719 20.1326 19.6022 19.6022Z"
      />
    </symbol>
    <symbol id="ic-docs-attachment-render-buble" viewBox="0 0 36 50">
      <g transform="translate(.5 .5)">
        <use xlink:href="#a3" />
        <use xlink:href="#b3" />
        <use xlink:href="#c3" />
        <use xlink:href="#d3" />
      </g>
      <defs>
        <path
          id="a3"
          d="M7 21.7h20.1a1.3 1.3 0 1 1 0 2.6h-20a1.3 1.3 0 1 1 0-2.6z"
        />
        <path
          id="b3"
          d="M27.1 28.8h-20a1.3 1.3 0 1 0 0 2.7h20a1.3 1.3 0 1 0 0-2.7z"
        />
        <path
          id="c3"
          d="M7 36h10.7a1.3 1.3 0 1 1 0 2.6H7.1a1.3 1.3 0 1 1 0-2.7z"
        />
        <path
          id="d3"
          fill-rule="evenodd"
          d="M5.3 5a5.5 5.5 0 0 1 11 0h14.6c2.5 0 4.5 2 4.5 4.5v28c0 .5-.2 1-.5 1.4l-9.6 9.6c-.4.3-.8.5-1.3.5H4.5C2 49 0 47 0 44.5v-35C0 7 2 5 4.5 5h.8zM9 5h3.5A1.8 1.8 0 0 0 9 5zM4.5 8.7c-.5 0-.8.4-.8.8v35c0 .5.3.8.8.8h17.7v-7.7c0-1 .8-1.9 1.8-1.9h7.8V9.5c0-.4-.4-.8-.9-.8H16.2v5.7a4.3 4.3 0 0 1-8.5 0V12a1.8 1.8 0 1 1 3.7 0v2.4c0 .3.3.6.6.6s.6-.3.6-.6V8.7H4.5zm21.3 30.7v3.3l3.4-3.3h-3.4z"
        />
      </defs>
    </symbol>
    <symbol id="ic-docs-upload" viewBox="0 0 36 45">
      <g transform="translate(0 .5)">
        <use xlink:href="#a4" />
        <use xlink:href="#b4" />
        <use xlink:href="#c4" />
        <use xlink:href="#d4" />
      </g>
      <defs>
        <path
          id="a4"
          d="M26 8.5H10c-1.2 0-2 .7-2 1.5s.8 1.5 2 1.5h16c1 0 2-.7 2-1.5s-1-1.5-2-1.5z"
        />
        <path
          id="b4"
          d="M10 15.5h16c1 0 2 .7 2 1.5s-1 1.5-2 1.5H10c-1.2 0-2-.7-2-1.5s.8-1.5 2-1.5z"
        />
        <path
          id="c4"
          d="M9.3 22.5h11.2c.8 0 1.4.7 1.4 1.5s-.6 1.5-1.4 1.5H9.3c-.7 0-1.4-.7-1.4-1.5s.7-1.5 1.4-1.5z"
        />
        <path
          id="d4"
          fill-rule="evenodd"
          d="M11 0H4.4C2 0 0 2 0 4.5v35C0 42 2 44 4.5 44H24c.5 0 1-.2 1.3-.6l9.6-9.6c.3-.3.5-.8.5-1.3v-28C35.4 2 33.4 0 31 0H11zM3.6 4.5c0-.5.3-.8.8-.8h26.4c.5 0 .9.3.9.8v26.2H24c-1 0-1.8.8-1.8 1.8v7.8H4.5a.8.8 0 0 1-.8-.8v-35zm22.1 33.2v-3.3h3.4l-3.4 3.3z"
        />
      </defs>
    </symbol>
    <symbol id="ic-envelope" viewBox="0 0 500 500">
      <path
        d="M354.2 312.5l-60.6-65.7 60.6-60.7a2 2 0 0 1 3.4 1.4v123.7a2 2 0 0 1-3.4 1.3zm-92.5-33.7a18.5 18.5 0 0 1-13.2 5.5h-.1c-5 0-9.8-2-13.4-5.6l-18-17.9-61.5 62.7a2 2 0 0 0 1.4 3.4h187a2 2 0 0 0 1.5-3.3l-61.6-67-22.1 22.2zm-13.3-8.5a5 5 0 0 0 3.5-1.4l91.7-91.9a2 2 0 0 0-1.4-3.4h-188a2 2 0 0 0-1.4 3.4l92 91.9a5 5 0 0 0 3.6 1.4zm-106-79.2V312a2 2 0 0 0 3.5 1.4l61.3-62.4-61.3-61.3a2 2 0 0 0-3.4 1.5z"
      />
    </symbol>
    <symbol id="ic-trash" viewBox="0 0 39 48">
      <use xlink:href="#a8" />
      <use xlink:href="#b8" />
      <use xlink:href="#c8" />
      <use xlink:href="#d" />
      <defs>
        <path
          id="a8"
          d="M18 36.6V25.4c0-.8.7-1.4 1.5-1.4s1.5.6 1.5 1.4v11.2c0 .8-.7 1.4-1.5 1.4s-1.5-.6-1.5-1.4z"
        />
        <path
          id="b8"
          d="M24 25.4v11.2c0 .8.7 1.4 1.5 1.4s1.5-.6 1.5-1.4V25.4c0-.8-.7-1.4-1.5-1.4s-1.5.6-1.5 1.4z"
        />
        <path
          id="c8"
          d="M12 36.6V25.4c0-.8.7-1.4 1.5-1.4s1.5.6 1.5 1.4v11.2c0 .8-.7 1.4-1.5 1.4s-1.5-.6-1.5-1.4z"
        />
        <path
          id="d"
          fill-rule="evenodd"
          d="M28.2 6h7.4C37.5 6 39 7.8 39 9.6V16c0 1.8-1.5 3.4-3.4 3.4h-.2v23.9c0 2.6-2.1 4.7-4.6 4.7H8.2a4.7 4.7 0 0 1-4.6-4.7V19.4h-.2A3.5 3.5 0 0 1 0 16V9.5c0-1.8 1.5-3.4 3.4-3.4h7.4V3.5c0-2 1.5-3.5 3.4-3.5h10.6c1.9 0 3.4 1.6 3.4 3.5V6zM24 4.5h-8.8v1.7H24V4.4zm10.7 6H4.3V15h30.3v-4.5zm-3.8 33.2c.2 0 .3-.1.3-.3v-24H7.9v23.9c0 .2.1.3.3.3h22.6z"
        />
      </defs>
    </symbol>
    <symbol id="ic-chevron-down" viewBox="0 0 1792 1792">
      <path
        d="M1683 808l-742 741q-19 19-45 19t-45-19l-742-741q-19-19-19-45.5t19-45.5l166-165q19-19 45-19t45 19l531 531 531-531q19-19 45-19t45 19l166 165q19 19 19 45.5t-19 45.5z"
      />
    </symbol>
    <symbol
      id="ic-chevron-left"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="#0A0A0A"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.7071 5.29289C15.3166 4.90237 14.6834 4.90237 14.2929 5.29289L8.29289 11.2929C7.90237 11.6834 7.90237 12.3166 8.29289 12.7071L14.2929 18.7071C14.6834 19.0976 15.3166 19.0976 15.7071 18.7071C16.0976 18.3166 16.0976 17.6834 15.7071 17.2929L10.4142 12L15.7071 6.70711C16.0976 6.31658 16.0976 5.68342 15.7071 5.29289Z"
        fill="inherit"
      />
    </symbol>
    <symbol
      id="ic-chevron-right"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.29289 5.29289C8.68342 4.90237 9.31658 4.90237 9.70711 5.29289L15.7071 11.2929C16.0976 11.6834 16.0976 12.3166 15.7071 12.7071L9.70711 18.7071C9.31658 19.0976 8.68342 19.0976 8.29289 18.7071C7.90237 18.3166 7.90237 17.6834 8.29289 17.2929L13.5858 12L8.29289 6.70711C7.90237 6.31658 7.90237 5.68342 8.29289 5.29289Z"
        fill="#0A0A0A"
      />
    </symbol>
    <symbol id="ic-image" viewBox="0 0 512 512">
      <path d="M368 224a48 48 0 1 0 0-96 48 48 0 0 0 0 96z" />
      <path
        d="M452 64H60a28 28 0 0 0-28 28.3v327.4A28 28 0 0 0 60 448h392a28 28 0 0 0 28-28.3V92.3A28 28 0 0 0 452 64zM348.9 261.7c-3-3.5-7.6-6.2-12.8-6.2-5.1 0-8.7 2.4-12.8 5.7L304.6 277c-3.9 2.8-7 4.7-11.5 4.7-4.3 0-8.2-1.6-11-4.1l-4.3-4.1-53.8-58.2a22 22 0 0 0-33.5.3L64 368.2V107.7c1-6.8 6.3-11.7 13.1-11.7h357.7c6.9 0 12.5 5.1 12.9 12l.3 260.4-99.1-106.7z"
      />
    </symbol>
    <symbol id="ic-chat-buble" viewBox="0 0 24 24">
      <path
        d="M2 2a1 1 0 0 0-1 1v13c0 .5.4 1 1 1h2l2.8 3.3c.4.4 1 .4 1.3 0L11 17h11c.6 0 1-.4 1-1V3c0-.5-.4-1-1-1H2zm3.2 4l-.2.2v.6l.2.2h12.6l.2-.2v-.6l-.2-.2H5.2zm0 3l-.2.2v.6l.2.2h12.6l.2-.2v-.6l-.2-.2H5.2zm0 3l-.2.2v.6c0 .1 0 .2.2.2h8.6l.2-.2v-.6c0-.1 0-.2-.2-.2H5.2z"
        fill-rule="evenodd"
      />
    </symbol>
    <symbol id="ic-clock" viewBox="0 0 24 24">
      <path
        d="M16.3 21l2 2 .8-.7-2-2a9 9 0 1 0-10.3 0l-2 2 .7.7 2.1-2.1a9 9 0 0 0 8.7 0zM12 21a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm0-8V7h1v7H8v-1h4zM6.9 3.7a1 1 0 0 0-1.4-.2L3.9 4.7a1 1 0 0 0-.2 1.4l.5.6-.6.9-.7-.9A2 2 0 0 1 3.3 4l1.6-1.2a2 2 0 0 1 2.8.3l.5.7-1 .5-.3-.5zM20.3 6c.3-.4.2-1-.2-1.4l-1.6-1.2a1 1 0 0 0-1.4.2l-.4.5a10 10 0 0 0-1-.5l.6-.7c.7-.8 2-1 2.8-.3l1.6 1.2c.9.7 1 2 .4 2.8l-.7.9a10 10 0 0 0-.6-.9l.5-.6z"
        fill-rule="evenodd"
      />
    </symbol>
    <symbol id="ic-link-out" viewBox="0 0 20 20">
      <path
        id="path0_fill"
        d="M 2.177 5.3125C 2.177 3.64404 3.46191 2.29175 5.04688 2.29175L 6.52075 2.29175C 7.12207 2.29175 7.60938 1.77856 7.60938 1.14575C 7.60938 0.512939 7.12207 0 6.52075 0L 5.04688 0C 2.25952 0 0 2.37842 0 5.3125L 0 14.6875C 0 17.6216 2.25952 20 5.04688 20L 14.9531 20C 17.7405 20 20 17.6216 20 14.6875L 20 14.0833C 20 13.4504 19.5127 12.9375 18.9114 12.9375C 18.3103 12.9375 17.823 13.4504 17.823 14.0833L 17.823 14.6875C 17.823 16.356 16.5381 17.7083 14.9531 17.7083L 5.04688 17.7083C 3.46191 17.7083 2.177 16.356 2.177 14.6875L 2.177 5.3125Z"
      />
      <path
        id="path1_fill"
        d="M 11.9844 0C 11.3833 0 10.8958 0.512939 10.8958 1.14575C 10.8958 1.77856 11.3833 2.29175 11.9844 2.29175L 16.437 2.29175L 10.2021 9.45142C 9.79582 9.91797 9.82585 10.6428 10.269 11.0703C 10.7121 11.498 11.4006 11.4663 11.8068 11L 17.823 4.09155L 17.823 8.4375C 17.823 9.07031 18.3103 9.58325 18.9114 9.58325C 19.5127 9.58325 20 9.07031 20 8.4375L 20 1.14575C 20 0.512939 19.5127 0 18.9114 0L 11.9844 0Z"
      />
    </symbol>
    <symbol id="ic-phone" viewBox="0 0 18 18">
      <path
        d="M3.6 7.8c1.4 2.8 3.8 5.1 6.6 6.6l2.2-2.2c.3-.3.7-.4 1-.2 1.1.4 2.3.6 3.6.6.6 0 1 .4 1 1V17c0 .6-.4 1-1 1A17 17 0 0 1 0 1c0-.6.4-1 1-1h3.5c.6 0 1 .4 1 1 0 1.2.2 2.4.6 3.6.1.3 0 .7-.2 1L3.6 7.8z"
        fill-rule="evenodd"
      />
    </symbol>
    <symbol id="ic-user" viewBox="0 0 1792 1792">
      <path
        d="M1600 1405q0 120-73 189.5t-194 69.5H459q-121 0-194-69.5T192 1405q0-53 3.5-103.5t14-109T236 1084t43-97.5 62-81 85.5-53.5T538 832q9 0 42 21.5t74.5 48 108 48T896 971t133.5-21.5 108-48 74.5-48 42-21.5q61 0 111.5 20t85.5 53.5 62 81 43 97.5 26.5 108.5 14 109 3.5 103.5zm-320-893q0 159-112.5 271.5T896 896 624.5 783.5 512 512t112.5-271.5T896 128t271.5 112.5T1280 512z"
      />
    </symbol>
    <symbol id="ic-smiley" viewBox="0 0 24 24">
      <path
        d="M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm5.507 13.941c-1.512 1.195-3.174 1.931-5.506 1.931-2.334 0-3.996-.736-5.508-1.931l-.493.493c1.127 1.72 3.2 3.566 6.001 3.566 2.8 0 4.872-1.846 5.999-3.566l-.493-.493zm-9.007-5.941c-.828 0-1.5.671-1.5 1.5s.672 1.5 1.5 1.5 1.5-.671 1.5-1.5-.672-1.5-1.5-1.5zm7 0c-.828 0-1.5.671-1.5 1.5s.672 1.5 1.5 1.5 1.5-.671 1.5-1.5-.672-1.5-1.5-1.5z"
      />
    </symbol>
    <symbol id="ic-file-attachment" viewBox="0 0 16 16">
      <path
        d="M14.2929 7.36678L8.16621 13.4934C7.41565 14.244 6.39767 14.6657 5.33621 14.6657C4.27475 14.6657 3.25677 14.244 2.50621 13.4934C1.75565 12.7429 1.33398 11.7249 1.33398 10.6634C1.33398 9.60199 1.75565 8.58401 2.50621 7.83344L8.63288 1.70678C9.13325 1.2064 9.81191 0.925293 10.5195 0.925293C11.2272 0.925293 11.9058 1.2064 12.4062 1.70678C12.9066 2.20715 13.1877 2.88581 13.1877 3.59344C13.1877 4.30108 12.9066 4.97973 12.4062 5.48011L6.27288 11.6068C6.02269 11.857 5.68336 11.9975 5.32954 11.9975C4.97572 11.9975 4.6364 11.857 4.38621 11.6068C4.13602 11.3566 3.99547 11.0173 3.99547 10.6634C3.99547 10.3096 4.13602 9.9703 4.38621 9.72011L10.0462 4.06678"
        stroke="white"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </symbol>
    <symbol id="ic-ig-attachment" viewBox="83 54 30 30">
      <path
        fill-rule="evenodd"
        d="m 92.338123,54.069246 c -4.659122,0 -8.41034,3.750699 -8.41034,8.409821 v 12.575976 c 0,4.659125 3.751218,8.409824 8.41034,8.409824 h 12.575457 c 4.65913,0 8.40983,-3.750699 8.40983,-8.409824 V 62.479067 c 0,-4.659122 -3.7507,-8.409821 -8.40983,-8.409821 z m -0.06976,2.598806 h 12.714467 c 3.18102,0 5.74229,2.560754 5.74229,5.741771 V 75.12429 c 0,3.181016 -2.56127,5.741768 -5.74229,5.741768 H 92.268363 c -3.181017,0 -5.741768,-2.560752 -5.741768,-5.741768 V 62.409823 c 0,-3.181017 2.560751,-5.741771 5.741768,-5.741771 z m 14.156247,2.464451 a 1.7481399,1.7481399 0 0 0 -1.74719,1.748213 1.7481399,1.7481399 0 0 0 1.74822,1.748213 1.7481399,1.7481399 0 0 0 1.74821,-1.748213 1.7481399,1.7481399 0 0 0 -1.74821,-1.748213 1.7481399,1.7481399 0 0 0 -0.001,0 z m -7.816066,2.126485 a 7.4886531,7.4886531 0 0 0 -7.443988,7.488431 7.4886531,7.4886531 0 0 0 7.488946,7.48843 7.4886531,7.4886531 0 0 0 7.488438,-7.48843 7.4886531,7.4886531 0 0 0 -7.488438,-7.488431 7.4886531,7.4886531 0 0 0 -0.04496,0 z m 0.01551,2.598291 a 4.8900669,4.8900669 0 0 1 0.02945,0 4.8900669,4.8900669 0 0 1 4.890146,4.89014 4.8900669,4.8900669 0 0 1 -4.890146,4.89014 4.8900669,4.8900669 0 0 1 -4.89014,-4.89014 4.8900669,4.8900669 0 0 1 4.860687,-4.89014 z"
        style="
          opacity: 1;
          fill: #979797;
          fill-opacity: 1;
          stroke-width: 0.264583;
        "
      />
    </symbol>
    <symbol id="ic-image-attachment" viewBox="0 0 20 20">
      <path
        fill-rule="evenodd"
        d="M 9 9C 10.6567 9 12 7.65686 12 6C 12 4.34314 10.6567 3 9 3C 7.34326 3 6 4.34314 6 6C 6 7.65686 7.34326 9 9 9ZM 11 6C 11 7.10455 10.1045 8 9 8C 7.89551 8 7 7.10455 7 6C 7 4.89545 7.89551 4 9 4C 10.1045 4 11 4.89545 11 6Z"
      />
      <path
        fill-rule="evenodd"
        d="M 2.49414 0C 1.1167 0 0 1.24371 0 2.77789L 0 17.2221C 0 18.7562 1.1167 20 2.49414 20L 17.5059 20C 18.8835 20 20 18.7562 20 17.2221L 20 2.67212C 20 1.19635 18.926 0 17.6011 0L 2.49414 0ZM 2.49414 1.11115C 1.66772 1.11115 0.997559 1.85742 0.997559 2.77789L 0.997559 13.8889L 3.42456 11.7316C 4.3252 10.9309 5.66895 10.8868 6.62036 11.6267L 8.41357 13.0214C 9.0105 13.4858 9.86011 13.4329 10.395 12.898L 14.2324 9.06067C 15.2087 8.08435 16.7915 8.08435 17.7678 9.06067L 19.0024 10.2952L 19.0024 2.67212C 19.0024 1.81 18.375 1.11115 17.6011 1.11115L 2.49414 1.11115ZM 0.997559 17.2221L 0.997559 15.2268L 4.08887 12.4789C 4.62939 11.9986 5.43555 11.9721 6.00635 12.4161L 7.79956 13.8107C 8.79468 14.5848 10.2107 14.4966 11.1021 13.6051L 14.9395 9.76776C 15.5254 9.18201 16.4751 9.18201 17.0608 9.76776L 19.0024 11.7095L 19.0024 17.2221C 19.0024 18.1426 18.3325 18.8889 17.5059 18.8889L 2.49414 18.8889C 1.66772 18.8889 0.997559 18.1426 0.997559 17.2221Z"
      />
    </symbol>
    <symbol id="ic-send-message" viewBox="0 0 24 24">
      <path
        fill-rule="evenodd"
        d="M 0.0115851 2.04123C -0.144872 0.603643 1.31315 -0.445178 2.58651 0.188973L 22.9904 10.3504C 24.3365 11.0208 24.3365 12.9792 22.9904 13.6496L 2.58651 23.811C 1.31315 24.4452 -0.144872 23.3964 0.011585 21.9588L 0.865213 14.1153C 0.95705 13.2715 1.60379 12.6021 2.42898 12.4968L 6.32188 12L 2.42898 11.5032C 1.60379 11.3979 0.95705 10.7285 0.865213 9.88468L 0.0115851 2.04123ZM 2.06106 1.28869C 1.63661 1.07731 1.1506 1.42691 1.20275 1.90611L 2.05638 9.74956C 2.08699 10.0308 2.30257 10.254 2.57764 10.2891L 6.47054 10.7859C 7.87033 10.9645 7.87033 13.0355 6.47054 13.2141L 2.57764 13.7109C 2.30257 13.746 2.08699 13.9692 2.05638 14.2504L 1.20275 22.0939C 1.1506 22.5731 1.63661 22.9227 2.06106 22.7113L 22.465 12.5499C 22.9137 12.3264 22.9137 11.6736 22.465 11.4501L 2.06106 1.28869Z"
      />
    </symbol>
    <symbol id="ic-minimize" viewBox="0 0 24 24" fill="none">
      <path
        d="M18 6L6.00081 17.9992M17.9992 18L6 6.00085"
        stroke="#0A0A0A"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </symbol>
    <symbol id="ic-load" viewBox="0 0 10 10">
      <path
        fill-rule="evenodd"
        d="M 5 1C 2.79086 1 1 2.79086 1 5C 1 7.20914 2.79086 9 5 9C 7.20914 9 9 7.20914 9 5C 9 4.72386 9.22386 4.5 9.5 4.5C 9.77614 4.5 10 4.72386 10 5C 10 7.76142 7.76142 10 5 10C 2.23858 10 0 7.76142 0 5C 0 2.23858 2.23858 0 5 0C 5.27614 0 5.5 0.223858 5.5 0.5C 5.5 0.776142 5.27614 1 5 1Z"
      />
    </symbol>
    <symbol id="ic-check" viewBox="0 0 12 9">
      <path
        fill-rule="evenodd"
        d="M 11.7985 0.111549C 12.0323 0.285046 12.0678 0.598796 11.8779 0.812329L 4.37336 8.84207C 4.17187 9.05766 3.83437 9.05172 3.6402 8.82917L 0.134965 4.8116C -0.0634062 4.60454 -0.0404331 4.28982 0.186277 4.10864C 0.412988 3.92746 0.757585 3.94845 0.955956 4.1555L 4 7.7013L 11.0312 0.184044C 11.2212 -0.0294899 11.5647 -0.0619468 11.7985 0.111549Z"
      />
    </symbol>
    <symbol id="ic-double-check" viewBox="0 0 16 9">
      <path
        d="M 6.77422 6.27328L 6.08575 5.47144L 5.37432 6.23204L 6.06866 7.02799L 6.77422 6.27328Z"
      />
      <path
        d="M 5.37432 7.77099L 4.37334 8.84207C 4.17193 9.05767 3.83453 9.05172 3.64019 8.82916L 0.135063 4.81161C -0.0634234 4.60454 -0.0404742 4.2898 0.186332 4.10861C 0.413139 3.92748 0.757621 3.94841 0.956108 4.15549L 4.00005 7.70129L 4.67974 6.97472L 5.37432 7.77099Z"
      />
      <path
        d="M 6.78081 4.72832L 7.46905 5.52985L 11.878 0.812304C 12.0679 0.598776 12.0323 0.285033 11.7986 0.111553C 11.5648 -0.0619265 11.2212 -0.0295244 11.0313 0.184066L 6.78081 4.72832Z"
      />
      <path
        fill-rule="evenodd"
        d="M 15.7985 0.111549C 16.0323 0.285046 16.0678 0.598796 15.8779 0.812329L 8.37336 8.84207C 8.17187 9.05766 7.83437 9.05172 7.6402 8.82917L 4.13497 4.8116C 3.93659 4.60454 3.95957 4.28982 4.18628 4.10864C 4.41299 3.92746 4.75759 3.94845 4.95596 4.1555L 8 7.7013L 15.0312 0.184044C 15.2212 -0.0294899 15.5647 -0.0619468 15.7985 0.111549Z"
      />
    </symbol>
    <symbol
      id="ic-reply"
      width="16"
      height="10"
      viewBox="0 0 16 10"
      fill="none"
    >
      <path
        d="M4.78027 0.71967C4.48738 0.426777 4.01262 0.426777 3.71973 0.71967L0.719727 3.71967C0.677054 3.76234 0.642543 3.81005 0.612305 3.85932C0.591924 3.89252 0.572708 3.92648 0.557617 3.96283C0.536906 4.01283 0.522122 4.06453 0.512695 4.11713C0.504972 4.16029 0.5 4.20456 0.5 4.24994C0.5 4.29499 0.505083 4.33892 0.512695 4.38178C0.522058 4.43441 0.536961 4.48603 0.557617 4.53608C0.566636 4.55788 0.578885 4.57787 0.589844 4.59858C0.624057 4.66331 0.665244 4.72573 0.719727 4.78022L3.71973 7.78022C4.01262 8.07311 4.48738 8.07311 4.78027 7.78022C5.07317 7.48732 5.07317 7.01256 4.78027 6.71967L3.06055 4.99994H11.75C12.3467 4.99994 12.9189 5.23717 13.3408 5.65912C13.7628 6.08108 14 6.65321 14 7.24994V8.74994C14 9.16416 14.3358 9.49994 14.75 9.49994C15.1642 9.49994 15.5 9.16416 15.5 8.74994V7.24994C15.5 6.25538 15.1046 5.30184 14.4014 4.59858C13.6981 3.89531 12.7446 3.49994 11.75 3.49994H3.06055L4.78027 1.78022C5.07317 1.48732 5.07317 1.01256 4.78027 0.71967Z"
        fill="#0A0A0A"
      />
    </symbol>
    <symbol id="ic-quote" viewBox="0 0 11 13">
      <path
        id="path0_fill"
        fill-rule="evenodd"
        d="M 3.42639 5.04879C 3.20799 5.13423 2.97257 5.18074 2.72708 5.18074L 2.04983 5.18074C 0.917708 5.18074 0 4.19161 0 2.97145L 0 2.20928C 0 0.989122 0.917708 0 2.04983 0L 2.72708 0C 3.85903 0 4.77674 0.989122 4.77674 2.20928L 4.77674 3.73138C 4.77674 4.58025 2.34566 11.7371 1.95156 12.6038C 1.69479 13.1685 0.902257 13.1685 0.902257 12.2253C 0.902257 11.8023 3.28785 5.36084 3.42639 5.04879Z"
      />
      <path
        id="path1_fill"
        fill-rule="evenodd"
        d="M 9.64965 5.04879C 9.43125 5.13423 9.19583 5.18074 8.95035 5.18074L 8.27309 5.18074C 7.14097 5.18074 6.22326 4.19161 6.22326 2.97145L 6.22326 2.20928C 6.22326 0.989122 7.14097 0 8.27309 0L 8.95035 0C 10.0823 0 11 0.989122 11 2.20928L 11 3.73138C 11 4.58025 8.63333 11.6176 8.17483 12.6038C 7.9 13.1949 7.16667 13.1685 7.12552 12.2253C 7.10698 11.8003 9.51111 5.36084 9.64965 5.04879Z"
      />
    </symbol>
    <symbol id="ic-more-horiz" viewBox="0 0 11 13">
      <g id="Canvas" fill-rule="evenodd">
        <g id="dot">
          <g id="Ellipse">
            <circle cx="1" cy="1" r="1" fill-rule="evenodd" />
          </g>
          <g id="Ellipse_2">
            <circle
              cx="1"
              cy="1"
              r="1"
              transform="translate(5 0)"
              fill-rule="evenodd"
            />
          </g>
          <g id="Ellipse_3">
            <circle
              cx="1"
              cy="1"
              r="1"
              transform="translate(10 0)"
              fill-rule="evenodd"
            />
          </g>
        </g>
      </g>
    </symbol>
    <symbol id="ic-reload" viewBox="0 0 24 24" fill="none">
      <path
        d="M23 4V10H17"
        stroke="#23B098"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M1 20V14H7"
        stroke="#23B098"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3.51 9C4.01717 7.56678 4.87913 6.2854 6.01547 5.27542C7.1518 4.26543 8.52547 3.55976 10.0083 3.22426C11.4911 2.88875 13.0348 2.93434 14.4952 3.35677C15.9556 3.77921 17.2853 4.56471 18.36 5.64L23 10M1 14L5.64 18.36C6.71475 19.4353 8.04437 20.2208 9.50481 20.6432C10.9652 21.0657 12.5089 21.1112 13.9917 20.7757C15.4745 20.4402 16.8482 19.7346 17.9845 18.7246C19.1209 17.7146 19.9828 16.4332 20.49 15"
        stroke="#23B098"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </symbol>
    <symbol id="ic-info" viewBox="0 0 18 18" fill="none">
      <path
        d="M9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5Z"
        fill="white"
      />
      <path
        d="M9 6V9"
        stroke="#23B098"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9 12H9.00833"
        stroke="#23B098"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </symbol>
    <symbol id="ic-download" viewBox="0 0 24 24">
      <path
        d="M19.2188 24.0469H4.78125C3.51364 24.0454 2.29838 23.5412 1.40204 22.6448C0.505704 21.7485 0.00148868 20.5332 0 19.2656L0 4.82812C0.00148868 3.56052 0.505704 2.34525 1.40204 1.44891C2.29838 0.552579 3.51364 0.0483637 4.78125 0.046875H19.2188C20.4864 0.0483637 21.7016 0.552579 22.598 1.44891C23.4943 2.34525 23.9985 3.56052 24 4.82812V19.2656C23.9985 20.5332 23.4943 21.7485 22.598 22.6448C21.7016 23.5412 20.4864 24.0454 19.2188 24.0469ZM4.78125 1.92188C4.01073 1.92274 3.27202 2.22922 2.72718 2.77406C2.18234 3.31889 1.87587 4.05761 1.875 4.82812V19.2656C1.87587 20.0361 2.18234 20.7749 2.72718 21.3197C3.27202 21.8645 4.01073 22.171 4.78125 22.1719H19.2188C19.9893 22.171 20.728 21.8645 21.2728 21.3197C21.8177 20.7749 22.1241 20.0361 22.125 19.2656V4.82812C22.1241 4.05761 21.8177 3.31889 21.2728 2.77406C20.728 2.22922 19.9893 1.92274 19.2188 1.92188H4.78125Z"
        fill="currentColor"
      />
      <path
        d="M12 15.2511C11.7514 15.2511 11.5129 15.1524 11.3371 14.9765C11.1613 14.8007 11.0625 14.5623 11.0625 14.3136V5.59863C11.0625 5.34999 11.1613 5.11154 11.3371 4.93572C11.5129 4.7599 11.7514 4.66113 12 4.66113C12.2486 4.66113 12.4871 4.7599 12.6629 4.93572C12.8387 5.11154 12.9375 5.34999 12.9375 5.59863V14.3136C12.9375 14.5623 12.8387 14.8007 12.6629 14.9765C12.4871 15.1524 12.2486 15.2511 12 15.2511Z"
        fill="currentColor"
      />
      <path
        d="M12.0001 15.9197C11.7919 15.9203 11.5858 15.8797 11.3935 15.8001C11.2012 15.7205 11.0266 15.6036 10.8798 15.4561L7.24412 11.821C7.06827 11.6451 6.96948 11.4066 6.96948 11.1579C6.96948 10.9092 7.06827 10.6707 7.24412 10.4949C7.41998 10.319 7.65848 10.2202 7.90717 10.2202C8.15586 10.2202 8.39437 10.319 8.57022 10.4949L12.0001 13.9252L15.4299 10.4949C15.517 10.4078 15.6203 10.3387 15.7341 10.2916C15.8479 10.2445 15.9698 10.2202 16.093 10.2202C16.2161 10.2202 16.338 10.2445 16.4518 10.2916C16.5656 10.3387 16.6689 10.4078 16.756 10.4949C16.8431 10.5819 16.9121 10.6853 16.9593 10.7991C17.0064 10.9128 17.0306 11.0348 17.0306 11.1579C17.0306 11.281 17.0064 11.403 16.9593 11.5167C16.9121 11.6305 16.8431 11.7339 16.756 11.821L13.1204 15.4561C12.9736 15.6036 12.7989 15.7205 12.6066 15.8001C12.4143 15.8797 12.2082 15.9203 12.0001 15.9197Z"
        fill="currentColor"
      />
      <path
        d="M16.0932 19.3389H7.90698C7.65834 19.3389 7.41989 19.2401 7.24407 19.0643C7.06825 18.8885 6.96948 18.65 6.96948 18.4014C6.96948 18.1527 7.06825 17.9143 7.24407 17.7385C7.41989 17.5626 7.65834 17.4639 7.90698 17.4639H16.0932C16.3419 17.4639 16.5803 17.5626 16.7561 17.7385C16.932 17.9143 17.0307 18.1527 17.0307 18.4014C17.0307 18.65 16.932 18.8885 16.7561 19.0643C16.5803 19.2401 16.3419 19.3389 16.0932 19.3389Z"
        fill="currentColor"
      />
    </symbol>
    <symbol id="ic-new-send-message" viewBox="0 0 24 24" fill="none">
      <path
        d="M22 2L11 13"
        stroke="inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M22 2L15 22L11 13L2 9L22 2Z"
        stroke="inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </symbol>
    <symbol id="ic-new-file-attachment" viewBox="0 0 24 24" fill="none">
      <path
        d="M21.4403 11.0499L12.2503 20.2399C11.1244 21.3658 9.59747 21.9983 8.00529 21.9983C6.41311 21.9983 4.88613 21.3658 3.76029 20.2399C2.63445 19.1141 2.00195 17.5871 2.00195 15.9949C2.00195 14.4027 2.63445 12.8758 3.76029 11.7499L12.9503 2.55992C13.7009 1.80936 14.7188 1.3877 15.7803 1.3877C16.8417 1.3877 17.8597 1.80936 18.6103 2.55992C19.3609 3.31048 19.7825 4.32846 19.7825 5.38992C19.7825 6.45138 19.3609 7.46936 18.6103 8.21992L9.41029 17.4099C9.03501 17.7852 8.52602 17.996 7.99529 17.996C7.46456 17.996 6.95557 17.7852 6.58029 17.4099C6.20501 17.0346 5.99418 16.5256 5.99418 15.9949C5.99418 15.4642 6.20501 14.9552 6.58029 14.5799L15.0703 6.09992"
        stroke="#565656"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </symbol>
    <symbol id="ic-new-image-attachment" viewBox="0 0 24 24" fill="none">
      <path
        d="M19 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3Z"
        stroke="#565656"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.5 10C9.32843 10 10 9.32843 10 8.5C10 7.67157 9.32843 7 8.5 7C7.67157 7 7 7.67157 7 8.5C7 9.32843 7.67157 10 8.5 10Z"
        stroke="#565656"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M21 15L16 10L5 21"
        stroke="#565656"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </symbol>
    <symbol id="ic-assistant" viewBox="0 0 24 25" fill="none">
      <path
        d="M3.74101 14.5749L10.1198 4.55105C10.9956 3.17492 13.0044 3.17492 13.8802 4.55105L20.259 14.5749C21.2031 16.0585 20.1374 17.9999 18.3788 17.9999H5.62116C3.86262 17.9999 2.79689 16.0585 3.74101 14.5749Z"
        stroke="currentColor"
        stroke-width="1.71428"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16.7592 22.4816C16.7592 23.7259 15.7504 24.7346 14.5061 24.7346L9.62446 24.7346C8.38013 24.7346 7.3714 23.7259 7.3714 22.4816C7.3714 21.2372 8.38013 20.2285 9.62446 20.2285L14.5061 20.2285C15.7504 20.2285 16.7592 21.2372 16.7592 22.4816Z"
        fill="currentColor"
      />
      <rect
        x="9.59998"
        y="9.94287"
        width="4.8"
        height="4.79999"
        rx="2.39999"
        fill="currentColor"
      />
    </symbol>
    <symbol id="ic-improve-text" viewBox="0 0 18 18" fill="none">
      <g clip-path="url(#clip0_3521_49218)">
        <path
          d="M9 11.8125V8.29688C9 7.52024 8.37039 6.89062 7.59375 6.89062C6.81711 6.89062 6.1875 7.52024 6.1875 8.29688V11.8125M6.1875 9.70312H9M11.8125 11.8125V6.1875M6.43721 4.21875H2.21846M2.21846 4.21875V0M2.21846 4.21875C3.72069 2.09197 6.19815 0.703125 9 0.703125C13.5822 0.703125 17.2969 4.41777 17.2969 9C17.2969 10.4709 16.9136 11.8522 16.2422 13.0501V16.2422H13.0501C11.8522 16.9136 10.4709 17.2969 9 17.2969C4.41777 17.2969 0.703125 13.5822 0.703125 9"
          stroke="currentColor"
          stroke-width="1.40625"
          stroke-miterlimit="10"
        />
      </g>
      <defs>
        <clipPath id="clip0_3521_49218">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </symbol>
    <symbol id="ic-ai-generate" viewBox="0 0 18 18" fill="none">
      <g clip-path="url(#clip0_3521_49014)">
        <path
          d="M9.00018 0C5.55631 0 2.75439 2.80171 2.75439 6.24579C2.75439 8.5372 4.02677 10.6508 6.02909 11.7432V13.0338C6.02909 13.3931 6.32036 13.6844 6.6797 13.6844H11.2992C11.6585 13.6844 11.9498 13.3931 11.9498 13.0338V11.7449C13.9654 10.6569 15.246 8.54244 15.246 6.24582C15.246 2.80171 12.4441 0 9.00018 0ZM11.0294 10.7501C10.7974 10.8557 10.6484 11.0871 10.6484 11.3422V12.3832H7.3303V11.3422C7.3303 11.0882 7.18239 10.8573 6.95188 10.7512C5.19245 9.94078 4.0556 8.17221 4.0556 6.24579C4.0556 3.51932 6.27371 1.3012 9.00018 1.3012C11.7267 1.3012 13.9448 3.51932 13.9448 6.24579C13.9448 8.17527 12.8004 9.94338 11.0294 10.7501Z"
          fill="currentColor"
        />
        <path
          d="M10.7999 14.5518H7.19992C6.84059 14.5518 6.54932 14.843 6.54932 15.2024C6.54932 15.5617 6.84055 15.853 7.19992 15.853H10.7999C11.1593 15.853 11.4505 15.5617 11.4505 15.2024C11.4505 14.843 11.1593 14.5518 10.7999 14.5518Z"
          fill="currentColor"
        />
        <path
          d="M9.75898 16.6987H8.24093C7.8816 16.6987 7.59033 16.99 7.59033 17.3493C7.59033 17.7087 7.8816 17.9999 8.24093 17.9999H9.75902C10.1183 17.9999 10.4096 17.7087 10.4096 17.3493C10.4096 16.99 10.1183 16.6987 9.75898 16.6987Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_3521_49014">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </symbol>
    <symbol id="ic-lengthen-text" viewBox="0 0 18 18" fill="none">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M2.25 5.0625C2.25 4.75184 2.50184 4.5 2.8125 4.5H15.1875C15.4982 4.5 15.75 4.75184 15.75 5.0625C15.75 5.37316 15.4982 5.625 15.1875 5.625H2.8125C2.50184 5.625 2.25 5.37316 2.25 5.0625ZM2.25 9C2.25 8.68934 2.50184 8.4375 2.8125 8.4375H15.1875C15.4982 8.4375 15.75 8.68934 15.75 9C15.75 9.31066 15.4982 9.5625 15.1875 9.5625H2.8125C2.50184 9.5625 2.25 9.31066 2.25 9ZM2.25 12.9375C2.25 12.6268 2.50184 12.375 2.8125 12.375H9C9.31066 12.375 9.5625 12.6268 9.5625 12.9375C9.5625 13.2482 9.31066 13.5 9 13.5H2.8125C2.50184 13.5 2.25 13.2482 2.25 12.9375Z"
        fill="currentColor"
      />
    </symbol>
    <symbol id="ic-shorten-text" viewBox="0 0 18 18" fill="none">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M2.25 6.75C2.25 6.43934 2.50184 6.1875 2.8125 6.1875H15.1875C15.4982 6.1875 15.75 6.43934 15.75 6.75C15.75 7.06066 15.4982 7.3125 15.1875 7.3125H2.8125C2.50184 7.3125 2.25 7.06066 2.25 6.75ZM2.25 11.8125C2.25 11.5018 2.50184 11.25 2.8125 11.25H15.1875C15.4982 11.25 15.75 11.5018 15.75 11.8125C15.75 12.1232 15.4982 12.375 15.1875 12.375H2.8125C2.50184 12.375 2.25 12.1232 2.25 11.8125Z"
        fill="currentColor"
      />
    </symbol>
    <symbol id="ic-translation-text" viewBox="0 0 18 18" fill="none">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4.5 1.5C4.5 1.08579 4.83579 0.75 5.25 0.75H6C6.41421 0.75 6.75 1.08579 6.75 1.5C6.75 1.91421 6.41421 2.25 6 2.25H5.25C4.83579 2.25 4.5 1.91421 4.5 1.5ZM8.98975 3H1.5C1.08579 3 0.75 3.33579 0.75 3.75C0.75 4.16421 1.08579 4.5 1.5 4.5H7.59861L6.91716 5.52218L5.625 6.81434L4.28033 5.46967C3.98744 5.17678 3.51256 5.17678 3.21967 5.46967C2.92678 5.76256 2.92678 6.23744 3.21967 6.53033L4.56434 7.875L2.46967 9.96967C2.17678 10.2626 2.17678 10.7374 2.46967 11.0303C2.76256 11.3232 3.23744 11.3232 3.53033 11.0303L5.625 8.93566L6.96967 10.2803C7.26256 10.5732 7.73744 10.5732 8.03033 10.2803C8.32322 9.98744 8.32322 9.51256 8.03033 9.21967L6.68566 7.875L8.03033 6.53033C8.06525 6.49541 8.09664 6.45712 8.12404 6.41603L9.40139 4.5H10.5C10.9142 4.5 11.25 4.16421 11.25 3.75C11.25 3.33579 10.9142 3 10.5 3H9.01163C9.00433 2.99989 8.99704 2.99989 8.98975 3ZM11.8858 6.98109C12.1949 6.83184 12.5551 6.83184 12.8642 6.98109C13.1331 7.11092 13.2788 7.33713 13.3512 7.45886C13.4271 7.58639 13.5049 7.74919 13.5814 7.90909L17.1766 15.4264C17.3553 15.8001 17.1973 16.2479 16.8236 16.4266C16.4499 16.6053 16.0021 16.4473 15.8234 16.0736L14.5926 13.5H10.1574L8.9266 16.0736C8.74789 16.4473 8.30009 16.6053 7.92641 16.4266C7.55273 16.2479 7.39469 15.8001 7.5734 15.4264L11.1571 7.93318C11.1609 7.92517 11.1648 7.91715 11.1686 7.90912C11.2451 7.74921 11.3229 7.5864 11.3988 7.45886C11.4712 7.33713 11.6169 7.11092 11.8858 6.98109ZM10.8748 12H13.8752L12.375 8.8633L10.8748 12Z"
        fill="currentColor"
      />
    </symbol>
    <symbol
      id="lengthen"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M2 6C2 5.44772 2.44772 5 3 5H21C21.5523 5 22 5.44772 22 6C22 6.55228 21.5523 7 21 7H3C2.44772 7 2 6.55228 2 6ZM2 12C2 11.4477 2.44772 11 3 11H21C21.5523 11 22 11.4477 22 12C22 12.5523 21.5523 13 21 13H3C2.44772 13 2 12.5523 2 12ZM2 18C2 17.4477 2.44772 17 3 17H15C15.5523 17 16 17.4477 16 18C16 18.5523 15.5523 19 15 19H3C2.44772 19 2 18.5523 2 18Z"
        fill="#A0A0A0"
      />
    </symbol>
    <symbol id="shorten" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M2 8.5C2 7.94772 2.44772 7.5 3 7.5H21C21.5523 7.5 22 7.94772 22 8.5C22 9.05228 21.5523 9.5 21 9.5H3C2.44772 9.5 2 9.05228 2 8.5ZM2 15.5C2 14.9477 2.44772 14.5 3 14.5H11.4477C12 14.5 12.4477 14.9477 12.4477 15.5C12.4477 16.0523 12 16.5 11.4477 16.5H3C2.44772 16.5 2 16.0523 2 15.5Z"
        fill="#A0A0A0"
      />
    </symbol>
    <symbol
      id="translation"
      width="24"
      height="24"
      viewBox="0 0 28 28"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6 2C6 1.44772 6.44772 1 7 1H8C8.55229 1 9 1.44772 9 2C9 2.55228 8.55229 3 8 3H7C6.44772 3 6 2.55228 6 2ZM11.9863 4H2C1.44772 4 1 4.44772 1 5C1 5.55228 1.44772 6 2 6H10.1315L9.22288 7.36291L7.5 9.08579L5.70711 7.29289C5.31658 6.90237 4.68342 6.90237 4.29289 7.29289C3.90237 7.68342 3.90237 8.31658 4.29289 8.70711L6.08579 10.5L3.29289 13.2929C2.90237 13.6834 2.90237 14.3166 3.29289 14.7071C3.68342 15.0976 4.31658 15.0976 4.70711 14.7071L7.5 11.9142L9.29289 13.7071C9.68342 14.0976 10.3166 14.0976 10.7071 13.7071C11.0976 13.3166 11.0976 12.6834 10.7071 12.2929L8.91421 10.5L10.7071 8.70711C10.7537 8.66054 10.7955 8.60949 10.8321 8.5547L12.5352 6H14C14.5523 6 15 5.55228 15 5C15 4.44772 14.5523 4 14 4H12.0155C12.0058 3.99986 11.996 3.99986 11.9863 4ZM15.8477 9.30812C16.2598 9.10912 16.7402 9.10912 17.1523 9.30812C17.5108 9.48122 17.7051 9.78284 17.8017 9.94515C17.9028 10.1152 18.0066 10.3322 18.1085 10.5455L22.9021 20.5685C23.1404 21.0668 22.9297 21.6638 22.4315 21.9021C21.9332 22.1404 21.3362 21.9297 21.0979 21.4315L19.4567 18H13.5433L11.9021 21.4315C11.6638 21.9297 11.0668 22.1404 10.5685 21.9021C10.0703 21.6638 9.85958 21.0668 10.0979 20.5685L14.8762 10.5776C14.8813 10.5669 14.8864 10.5562 14.8915 10.5455C14.9934 10.3323 15.0972 10.1152 15.1983 9.94515C15.2949 9.78284 15.4893 9.48122 15.8477 9.30812ZM14.4998 16H18.5002L16.5 11.8177L14.4998 16Z"
        fill="#A0A0A0"
      />
    </symbol>
    <symbol id="ic-arrow-right" viewBox="0 0 18 18" fill="none">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.21967 4.20921C6.51256 3.93026 6.98744 3.93026 7.28033 4.20921L11.7803 8.49492C12.0732 8.77387 12.0732 9.22613 11.7803 9.50508L7.28033 13.7908C6.98744 14.0697 6.51256 14.0697 6.21967 13.7908C5.92678 13.5118 5.92678 13.0596 6.21967 12.7806L10.1893 9L6.21967 5.21936C5.92678 4.94042 5.92678 4.48816 6.21967 4.20921Z"
        fill="currentColor"
      />
    </symbol>
    <symbol id="ic-back" width="24" height="24" viewBox="0 0 27 27" fill="none">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12 3.81818C16.5187 3.81818 20.1818 7.48131 20.1818 12C20.1818 16.5187 16.5187 20.1818 12 20.1818C7.48131 20.1818 3.81818 16.5187 3.81818 12C3.81818 7.48131 7.48131 3.81818 12 3.81818ZM22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12ZM11.3572 7.72081C10.1432 8.93474 8.91774 10.1382 7.7149 11.3631C7.36959 11.7148 7.37299 12.2958 7.72146 12.6435L11.3572 16.2792C11.7122 16.6342 12.2878 16.6342 12.6428 16.2792C12.9978 15.9242 12.9978 15.3486 12.6428 14.9935L10.5584 12.9091H15.6364C16.1384 12.9091 16.5455 12.5021 16.5455 12C16.5455 11.4979 16.1384 11.0909 15.6364 11.0909H10.5584L12.6428 9.00646C12.9978 8.65144 12.9978 8.07583 12.6428 7.72081C12.2878 7.36579 11.7122 7.36579 11.3572 7.72081Z"
        fill="#27B199"
      />
    </symbol>
    <symbol id="ic-search" viewBox="0 0 24 24" fill="none">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.1524 5.74188C11.8299 3.41937 8.06439 3.41937 5.74188 5.74188C3.41937 8.06439 3.41937 11.8299 5.74188 14.1524C8.06439 16.4749 11.8299 16.4749 14.1524 14.1524C16.4749 11.8299 16.4749 8.06439 14.1524 5.74188ZM4.32767 4.32767C7.43122 1.22411 12.4631 1.22411 15.5666 4.32767C18.4307 7.19172 18.6517 11.698 16.2297 14.8155L21.7071 20.2929C22.0976 20.6834 22.0976 21.3166 21.7071 21.7071C21.3166 22.0976 20.6834 22.0976 20.2929 21.7071L14.8155 16.2297C11.698 18.6517 7.19173 18.4307 4.32767 15.5666C1.22411 12.4631 1.22411 7.43122 4.32767 4.32767ZM11.6962 8.19807C10.7302 7.23208 9.16406 7.23208 8.19807 8.19807C7.80754 8.5886 7.17438 8.5886 6.78385 8.19807C6.39333 7.80755 6.39333 7.17438 6.78385 6.78386C8.53089 5.03682 11.3634 5.03682 13.1104 6.78386C13.501 7.17438 13.501 7.80755 13.1104 8.19807C12.7199 8.5886 12.0868 8.5886 11.6962 8.19807Z"
        fill="#0A0A0A"
      />
    </symbol>

    <symbol id="ic-knowledge-base" viewBox="0 0 18 18" fill="none">
      <path
        d="M12.7502 0H5.25024C4.25605 0.00119089 3.30291 0.396661 2.59991 1.09966C1.89691 1.80267 1.50144 2.7558 1.50024 3.75V15C1.50024 15.7956 1.81631 16.5587 2.37892 17.1213C2.94153 17.6839 3.70459 18 4.50024 18H12.7502C13.7444 17.9988 14.6976 17.6033 15.4006 16.9003C16.1036 16.1973 16.4991 15.2442 16.5002 14.25V3.75C16.4991 2.7558 16.1036 1.80267 15.4006 1.09966C14.6976 0.396661 13.7444 0.00119089 12.7502 0V0ZM15.0002 3.75V12H6.00024V1.5H12.7502C13.347 1.5 13.9193 1.73705 14.3412 2.15901C14.7632 2.58097 15.0002 3.15326 15.0002 3.75ZM4.50024 1.629V12C3.97347 11.9995 3.45595 12.1385 3.00024 12.4028V3.75C3.00031 3.28477 3.14459 2.83099 3.41322 2.45115C3.68185 2.07131 4.06162 1.78408 4.50024 1.629ZM12.7502 16.5H4.50024C4.10242 16.5 3.72089 16.342 3.43958 16.0607C3.15828 15.7794 3.00024 15.3978 3.00024 15C3.00024 14.6022 3.15828 14.2206 3.43958 13.9393C3.72089 13.658 4.10242 13.5 4.50024 13.5H15.0002V14.25C15.0002 14.8467 14.7632 15.419 14.3412 15.841C13.9193 16.2629 13.347 16.5 12.7502 16.5Z"
        fill="currentColor"
      />
    </symbol>
    <symbol id="ic-assistant-close" viewBox="0 0 24 24" fill="none">
      <g id="24px/Qiscus Icons/Close">
        <g id="Component">
          <g id="Stroke">
            <path
              id="Vector"
              d="M18 6L6 18"
              stroke="#0A0A0A"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              id="Vector_2"
              d="M6 6L18 18"
              stroke="#0A0A0A"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </g>
        </g>
      </g>
    </symbol>
    <symbol id="ic-ads-tracker" viewBox="0 0 24 24" fill="none">
      <g clip-path="url(#clip0_7068_27742)">
        <path
          d="M19 0H5C3.67441 0.00158786 2.40356 0.528882 1.46622 1.46622C0.528882 2.40356 0.00158786 3.67441 0 5L0 19C0.00158786 20.3256 0.528882 21.5964 1.46622 22.5338C2.40356 23.4711 3.67441 23.9984 5 24H16.343C16.9998 24.0016 17.6504 23.873 18.2572 23.6215C18.864 23.37 19.4149 23.0007 19.878 22.535L22.536 19.879C23.0017 19.4157 23.3709 18.8646 23.6222 18.2576C23.8735 17.6507 24.0019 16.9999 24 16.343V5C23.9984 3.67441 23.4711 2.40356 22.5338 1.46622C21.5964 0.528882 20.3256 0.00158786 19 0ZM2 19V5C2 4.20435 2.31607 3.44129 2.87868 2.87868C3.44129 2.31607 4.20435 2 5 2H19C19.7957 2 20.5587 2.31607 21.1213 2.87868C21.6839 3.44129 22 4.20435 22 5V15H18C17.2043 15 16.4413 15.3161 15.8787 15.8787C15.3161 16.4413 15 17.2043 15 18V22H5C4.20435 22 3.44129 21.6839 2.87868 21.1213C2.31607 20.5587 2 19.7957 2 19ZM18.464 21.121C18.0608 21.5198 17.5534 21.7971 17 21.921V18C17 17.7348 17.1054 17.4804 17.2929 17.2929C17.4804 17.1054 17.7348 17 18 17H21.922C21.8004 17.5546 21.5229 18.0629 21.122 18.465L18.464 21.121Z"
          fill="#A0A0A0"
        />
        <path
          d="M13.8182 5C13.2182 5 12.7273 5.49091 12.7273 6.09091V7.18182C12.7273 7.78182 13.2182 8.27273 13.8182 8.27273H14.9091V9.36364H12.7273V10.4545H14.9091C15.5091 10.4545 16 9.96364 16 9.36364V8.27273C16 7.67273 15.5091 7.18182 14.9091 7.18182H13.8182V6.09091H16V5H13.8182ZM8.36364 5V10.4545H10.5455C11.1455 10.4545 11.6364 9.96364 11.6364 9.36364V6.09091C11.6364 5.49091 11.1455 5 10.5455 5H8.36364ZM9.45455 6.09091H10.5455V9.36364H9.45455V6.09091ZM5.09091 5C4.49091 5 4 5.49091 4 6.09091V10.4545H5.09091V8.27273H6.18182V10.4545H7.27273V6.09091C7.27273 5.49091 6.78182 5 6.18182 5H5.09091ZM5.09091 6.09091H6.18182V7.18182H5.09091V6.09091Z"
          fill="#A0A0A0"
        />
      </g>
      <defs>
        <clipPath id="clip0_7068_27742">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </symbol>
    <symbol id="ic-download-borderless" viewBox="0 0 18 18" fill="none">
      <path
        d="M9.75 2.25C9.75 1.83579 9.41421 1.5 9 1.5C8.58579 1.5 8.25 1.83579 8.25 2.25V9.43934L5.78033 6.96967C5.48744 6.67678 5.01256 6.67678 4.71967 6.96967C4.42678 7.26256 4.42678 7.73744 4.71967 8.03033L8.46891 11.7796C8.47079 11.7815 8.47269 11.7833 8.47459 11.7852C8.54535 11.8547 8.62646 11.9073 8.71291 11.9431C8.80134 11.9798 8.89831 12 9 12C9.2036 12 9.38825 11.9189 9.52339 11.7872C9.526 11.7846 9.52859 11.7821 9.53116 11.7795L13.2803 8.03033C13.5732 7.73744 13.5732 7.26256 13.2803 6.96967C12.9874 6.67678 12.5126 6.67678 12.2197 6.96967L9.75 9.43934V2.25Z"
        fill="#27B199"
      />
      <path
        d="M2.25 10.5C2.66421 10.5 3 10.8358 3 11.25V14.25C3 14.4489 3.07902 14.6397 3.21967 14.7803C3.36032 14.921 3.55109 15 3.75 15H14.25C14.4489 15 14.6397 14.921 14.7803 14.7803C14.921 14.6397 15 14.4489 15 14.25V11.25C15 10.8358 15.3358 10.5 15.75 10.5C16.1642 10.5 16.5 10.8358 16.5 11.25V14.25C16.5 14.8467 16.2629 15.419 15.841 15.841C15.419 16.2629 14.8467 16.5 14.25 16.5H3.75C3.15326 16.5 2.58097 16.2629 2.15901 15.841C1.73705 15.419 1.5 14.8467 1.5 14.25V11.25C1.5 10.8358 1.83579 10.5 2.25 10.5Z"
        fill="#27B199"
      />
    </symbol>
    <symbol id="ic-wagroup" viewBox="0 0 48 48" fill="none">
      <circle cx="24" cy="24" r="24" fill="#F1F9EF" />
      <path
        d="M13 32V29.2C13 28.6334 13.146 28.1127 13.438 27.638C13.73 27.1634 14.1173 26.8007 14.6 26.55C15.6333 26.0334 16.6833 25.646 17.75 25.388C18.8167 25.13 19.9 25.0007 21 25C22.1 24.9994 23.1833 25.1287 24.25 25.388C25.3167 25.6474 26.3667 26.0347 27.4 26.55C27.8833 26.8 28.271 27.1627 28.563 27.638C28.855 28.1134 29.0007 28.634 29 29.2V32H13ZM31 32V29C31 28.2667 30.796 27.5624 30.388 26.887C29.98 26.2117 29.4007 25.6327 28.65 25.15C29.5 25.25 30.3 25.421 31.05 25.663C31.8 25.905 32.5 26.2007 33.15 26.55C33.75 26.8834 34.2083 27.254 34.525 27.662C34.8417 28.07 35 28.516 35 29V32H31ZM21 24C19.9 24 18.9583 23.6084 18.175 22.825C17.3917 22.0417 17 21.1 17 20C17 18.9 17.3917 17.9584 18.175 17.175C18.9583 16.3917 19.9 16 21 16C22.1 16 23.0417 16.3917 23.825 17.175C24.6083 17.9584 25 18.9 25 20C25 21.1 24.6083 22.0417 23.825 22.825C23.0417 23.6084 22.1 24 21 24ZM31 20C31 21.1 30.6083 22.0417 29.825 22.825C29.0417 23.6084 28.1 24 27 24C26.8167 24 26.5833 23.9794 26.3 23.938C26.0167 23.8967 25.7833 23.8507 25.6 23.8C26.05 23.2667 26.396 22.675 26.638 22.025C26.88 21.375 27.0007 20.7 27 20C26.9993 19.3 26.8787 18.625 26.638 17.975C26.3973 17.325 26.0513 16.7334 25.6 16.2C25.8333 16.1167 26.0667 16.0624 26.3 16.037C26.5333 16.0117 26.7667 15.9994 27 16C28.1 16 29.0417 16.3917 29.825 17.175C30.6083 17.9584 31 18.9 31 20ZM15 30H27V29.2C27 29.0167 26.9543 28.85 26.863 28.7C26.7717 28.55 26.6507 28.4334 26.5 28.35C25.6 27.9 24.6917 27.5627 23.775 27.338C22.8583 27.1134 21.9333 27.0007 21 27C20.0667 26.9994 19.1417 27.112 18.225 27.338C17.3083 27.564 16.4 27.9014 15.5 28.35C15.35 28.4334 15.229 28.55 15.137 28.7C15.045 28.85 14.9993 29.0167 15 29.2V30ZM21 22C21.55 22 22.021 21.8044 22.413 21.413C22.805 21.0217 23.0007 20.5507 23 20C22.9993 19.4494 22.8037 18.9787 22.413 18.588C22.0223 18.1974 21.5513 18.0014 21 18C20.4487 17.9987 19.978 18.1947 19.588 18.588C19.198 18.9814 19.002 19.452 19 20C18.998 20.548 19.194 21.019 19.588 21.413C19.982 21.807 20.4527 22.0027 21 22Z"
        fill="#27B199"
      />
    </symbol>
    <symbol
      id="ic-call"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="white"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.2572 3.74545C5.96579 2.97657 5.6142 2.77542 5.36521 2.77784L5.3564 2.77793V2.77788C4.20325 2.77788 3.58071 3.01942 3.25701 3.28226C2.96474 3.51958 2.79862 3.87043 2.79435 4.42308C2.78989 4.99987 2.96792 5.73052 3.31836 6.57043C3.66459 7.40028 4.15645 8.28335 4.7232 9.14847L4.72748 9.15501L4.72745 9.15503C6.88858 12.5181 10.6129 14.7875 14.6162 15.2207C14.9175 15.2438 15.2069 14.9783 15.2057 14.6818L15.2057 14.6782C15.2057 13.1414 15.0554 12.724 14.8451 12.4906C14.7317 12.3648 14.5406 12.2279 14.1481 12.0501C13.8029 11.8937 13.3748 11.7362 12.8006 11.525C12.7109 11.492 12.6175 11.4576 12.5204 11.4218L12.5183 11.421C12.3507 11.3587 12.217 11.3709 11.9781 11.5373C11.7633 11.6869 11.5879 11.8693 11.3638 12.1024C11.264 12.2062 11.1546 12.32 11.0278 12.4455C10.7423 12.7277 10.3019 12.7866 9.95124 12.5894C8.00408 11.4945 6.39163 9.90016 5.28419 7.97425C5.08397 7.62604 5.14366 7.18814 5.42995 6.90504C5.54574 6.79054 5.67318 6.67556 5.7849 6.57476C5.80337 6.55809 5.82141 6.54182 5.83889 6.526C5.97042 6.40699 6.08357 6.30234 6.18343 6.19771C6.39015 5.9811 6.46628 5.83816 6.48828 5.73616C6.58063 5.30795 6.53164 4.46954 6.2572 3.74545ZM7.93694 3.12045C8.31049 4.10608 8.41877 5.29238 8.24294 6.10768C8.11897 6.68245 7.77796 7.11445 7.48712 7.41919C7.39582 7.51485 7.30196 7.60548 7.21221 7.68914C8.00788 8.88142 9.0408 9.90142 10.248 10.6867C10.4582 10.4774 10.6998 10.2545 10.9464 10.0828C11.4965 9.69964 12.2526 9.42391 13.1475 9.75613C13.2397 9.79014 13.3304 9.82347 13.4195 9.85621C13.9837 10.0635 14.4839 10.2474 14.8943 10.4333C15.3764 10.6517 15.8282 10.9124 16.1835 11.3066C16.9103 12.1131 16.9999 13.2252 17 14.6769C17.0041 16.0361 15.7907 17.1108 14.4489 16.9909L14.4328 16.9893C9.89269 16.5014 5.67594 13.9388 3.21608 10.1132C2.60932 9.18667 2.0595 8.20668 1.66019 7.24963C1.26462 6.30154 0.993092 5.32039 1.00013 4.40946C1.00736 3.47439 1.31379 2.56161 2.11971 1.90721C2.89343 1.27896 3.99331 1.00063 5.35236 1.00008C6.79498 0.988682 7.58075 2.18066 7.93694 3.12045ZM17 14.6769C17 14.6774 17 14.6778 17 14.6782H16.1029L17 14.6746C17 14.6754 17 14.6762 17 14.6769Z"
        fill="inherit"
      />
    </symbol>
    <symbol id="ic-phone-outgoing-call" viewBox="0 0 14 14">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M1.75102 2.23998C2.30443 7.41088 6.56448 11.6819 11.7572 12.2487C11.9817 12.2676 12.0581 12.1987 12.1154 12.1177C12.2083 11.9866 12.2918 11.7261 12.2878 11.335C12.2839 10.9578 12.1983 10.5372 12.0456 10.1617C11.8901 9.77907 11.6892 9.50152 11.4987 9.35211C11.0326 8.98662 10.6517 8.89052 10.2953 8.94449C9.9065 9.00338 9.40267 9.26211 8.75651 9.90699C8.5179 10.1451 8.14973 10.1948 7.85654 10.0284C6.22872 9.10465 4.88072 7.7594 3.95491 6.13444C3.78752 5.84064 3.83743 5.47117 4.07676 5.23231C4.72277 4.58758 4.98095 4.08512 5.03958 3.69815C5.09331 3.34357 4.9974 2.964 4.63219 2.49908C4.48342 2.30968 4.20701 2.10976 3.82592 1.95489C3.45187 1.80288 3.03311 1.71762 2.65767 1.71376C2.26838 1.70976 2.0097 1.79285 1.87991 1.88478C1.80029 1.94119 1.7319 2.01633 1.75102 2.23998ZM4.39066 0.565256C4.92324 0.781693 5.45076 1.11289 5.81178 1.57249C6.35794 2.26777 6.65443 3.05316 6.52266 3.92285C6.42016 4.59935 6.07069 5.23918 5.54246 5.85698C6.217 6.88823 7.0992 7.76847 8.13292 8.44153C8.75219 7.91354 9.39321 7.56402 10.0707 7.46141C10.9409 7.32961 11.7272 7.62513 12.4243 8.17175C12.8856 8.53349 13.218 9.0625 13.4352 9.59676C13.6553 10.1381 13.7818 10.7446 13.7877 11.3197C13.7934 11.881 13.6841 12.498 13.3397 12.9845C12.9602 13.5204 12.3557 13.8088 11.6166 13.7421L11.6031 13.7407C5.70466 13.1011 0.884344 8.27169 0.258736 2.39213L0.257581 2.38041C0.19082 1.64309 0.478043 1.0396 1.01289 0.660748C1.49818 0.316997 2.11361 0.20809 2.67308 0.213837C3.2464 0.219727 3.85104 0.345961 4.39066 0.565256Z"
      />
    </symbol>
    <symbol id="ic-url" viewBox="0 0 18 18">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3.75 5.25C3.55109 5.25 3.36032 5.32902 3.21967 5.46967C3.07902 5.61032 3 5.80109 3 6V14.25C3 14.4489 3.07902 14.6397 3.21967 14.7803C3.36032 14.921 3.55109 15 3.75 15H12C12.1989 15 12.3897 14.921 12.5303 14.7803C12.671 14.6397 12.75 14.4489 12.75 14.25V9.75C12.75 9.33579 13.0858 9 13.5 9C13.9142 9 14.25 9.33579 14.25 9.75V14.25C14.25 14.8467 14.0129 15.419 13.591 15.841C13.169 16.2629 12.5967 16.5 12 16.5H3.75C3.15326 16.5 2.58097 16.2629 2.15901 15.841C1.73705 15.419 1.5 14.8467 1.5 14.25V6C1.5 5.40326 1.73705 4.83097 2.15901 4.40901C2.58097 3.98705 3.15326 3.75 3.75 3.75H8.25C8.66421 3.75 9 4.08579 9 4.5C9 4.91421 8.66421 5.25 8.25 5.25H3.75Z"
        fill="inherit"
      ></path>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.5 2.25C10.5 1.83579 10.8358 1.5 11.25 1.5H15.75C16.1642 1.5 16.5 1.83579 16.5 2.25V6.75C16.5 7.16421 16.1642 7.5 15.75 7.5C15.3358 7.5 15 7.16421 15 6.75V3H11.25C10.8358 3 10.5 2.66421 10.5 2.25Z"
        fill="inherit"
      ></path>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16.2803 1.71967C16.5732 2.01256 16.5732 2.48744 16.2803 2.78033L8.03033 11.0303C7.73744 11.3232 7.26256 11.3232 6.96967 11.0303C6.67678 10.7374 6.67678 10.2626 6.96967 9.96967L15.2197 1.71967C15.5126 1.42678 15.9874 1.42678 16.2803 1.71967Z"
        fill="inherit"
      ></path>
    </symbol>
    <symbol id="ic-quick-reply" viewBox="0 0 18 18">
      <g clip-path="url(#clip0_8538_6000)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M7.38922 1.55955C7.66638 1.67709 7.8464 1.94897 7.8464 2.25002V5.18184H8.36563C11.8479 5.18184 13.9685 6.89551 15.3445 9.05756C16.4149 10.7394 17.062 12.7464 17.5895 14.3826C17.7184 14.7825 17.8402 15.1602 17.9593 15.5056C18.0689 15.8234 17.9536 16.1753 17.6772 16.3666C17.4008 16.558 17.0309 16.5421 16.772 16.3277C16.2666 15.9094 15.8197 15.5314 15.4157 15.1897C14.2953 14.2421 13.5044 13.5731 12.7096 13.0941C11.7037 12.4879 10.7081 12.2046 9.00025 12.2046H7.8464V15.1364C7.8464 15.4439 7.65863 15.7203 7.3727 15.8336C7.08677 15.9469 6.76065 15.8742 6.54998 15.6501L0.203821 8.90012C-0.077096 8.60132 -0.0659235 8.1323 0.228902 7.84722L6.57506 1.71085C6.79148 1.50158 7.11206 1.442 7.38922 1.55955ZM1.80325 8.41147L6.3464 13.2437V11.4546C6.3464 11.0404 6.68219 10.7046 7.0964 10.7046H9.00025C10.9224 10.7046 12.1987 11.0349 13.4838 11.8094C14.1824 12.2304 14.8897 12.79 15.7094 13.4747C15.2855 12.2359 14.7883 10.9774 14.0791 9.86293C12.9166 8.03635 11.2296 6.68184 8.36563 6.68184H7.0964C6.68219 6.68184 6.3464 6.34605 6.3464 5.93184V4.0185L1.80325 8.41147Z"
          fill="inherit"
        ></path>
      </g>
      <defs>
        <clippath id="clip0_8538_6000">
          <rect width="18" height="18" fill="inherit"></rect>
        </clippath>
      </defs>
    </symbol>
    <symbol id="ic-note" viewBox="0 0 20 20">
      <path
        d="M13.75 0.916992C14.1642 0.916992 14.5 1.25278 14.5 1.66699V2.33984C15.2191 2.47758 15.8371 2.7356 16.3428 3.24121C16.9322 3.83087 17.1848 4.57295 17.3027 5.4502C17.4177 6.3059 17.416 7.39665 17.416 8.75L17.417 13.333C17.417 13.4156 17.3996 13.4941 17.375 13.5684C17.3689 13.5869 17.365 13.6061 17.3574 13.624C17.3195 13.714 17.2652 13.7952 17.1973 13.8633L12.1963 18.8643C12.155 18.9054 12.1084 18.9395 12.0596 18.9697C11.9852 19.0158 11.9032 19.0506 11.8145 19.0684C11.8119 19.0689 11.8092 19.0688 11.8066 19.0693C11.7669 19.0768 11.7262 19.0811 11.6846 19.082C11.6785 19.0822 11.6721 19.084 11.666 19.084H9.16602C7.81261 19.084 6.72191 19.0848 5.86621 18.9697C4.98897 18.8518 4.24686 18.5993 3.65723 18.0098C3.06762 17.4201 2.81428 16.678 2.69629 15.8008C2.58123 14.945 2.58301 13.8536 2.58301 12.5V8.75C2.58301 7.39671 2.58131 6.30589 2.69629 5.4502C2.81424 4.57292 3.06771 3.83088 3.65723 3.24121C4.16295 2.73548 4.78095 2.47756 5.5 2.33984V1.66699C5.5 1.25278 5.83579 0.916993 6.25 0.916992C6.66421 0.916992 7 1.25278 7 1.66699V2.19043C7.63068 2.16578 8.35065 2.16699 9.16602 2.16699H9.25V1.66699C9.25 1.25278 9.58579 0.916993 10 0.916992C10.4142 0.916992 10.75 1.25278 10.75 1.66699V2.16699H10.833C11.6487 2.16699 12.3691 2.16575 13 2.19043V1.66699C13 1.25278 13.3358 0.916993 13.75 0.916992ZM9.16602 3.66699C8.2933 3.66699 7.58641 3.66994 7 3.69434V4.16699C6.99984 4.58107 6.66411 4.91699 6.25 4.91699C5.83589 4.91699 5.50016 4.58106 5.5 4.16699V3.87891C5.13665 3.97961 4.90099 4.11854 4.71777 4.30176C4.45342 4.56625 4.2782 4.93884 4.18262 5.64941C4.08417 6.38198 4.08301 7.35425 4.08301 8.75V12.5C4.08301 13.8958 4.08415 14.868 4.18262 15.6006C4.27823 16.3115 4.45323 16.6847 4.71777 16.9492C4.98223 17.2136 5.35495 17.3878 6.06543 17.4834C6.79799 17.5819 7.77019 17.584 9.16602 17.584H10.918C10.9216 16.7615 10.9383 16.0654 11.0156 15.4902C11.1184 14.7264 11.3405 14.0638 11.8691 13.5352C12.3978 13.0067 13.0604 12.7843 13.8242 12.6816C14.399 12.6044 15.0943 12.5876 15.916 12.584V8.75C15.916 7.35421 15.9149 6.38199 15.8164 5.64941C15.7208 4.93892 15.5465 4.56624 15.2822 4.30176C15.099 4.11853 14.8635 3.97959 14.5 3.87891V4.16699C14.4998 4.58107 14.1641 4.91699 13.75 4.91699C13.3359 4.91699 13.0002 4.58106 13 4.16699V3.69434C12.4135 3.66992 11.7062 3.66699 10.833 3.66699H10.75V4.16699C10.7498 4.58107 10.4141 4.91699 10 4.91699C9.58589 4.91699 9.25016 4.58106 9.25 4.16699V3.66699H9.16602ZM14.832 14.1064C14.5263 14.1189 14.2598 14.1362 14.0234 14.168C13.4263 14.2483 13.1332 14.3923 12.9297 14.5957C12.7262 14.7992 12.5823 15.0923 12.502 15.6895C12.4701 15.926 12.4519 16.193 12.4395 16.499L14.832 14.1064ZM9.58398 10.916C9.99773 10.9163 10.3336 11.2523 10.334 11.666C10.334 12.08 9.99794 12.4157 9.58398 12.416H6.66699C6.25278 12.416 5.91699 12.0802 5.91699 11.666C5.91733 11.2521 6.25299 10.916 6.66699 10.916H9.58398ZM13.334 7.58301C13.7478 7.58331 14.0838 7.91912 14.084 8.33301C14.084 8.74703 13.7479 9.0827 13.334 9.08301H6.66699C6.25278 9.08301 5.91699 8.74722 5.91699 8.33301C5.91716 7.91893 6.25288 7.58301 6.66699 7.58301H13.334Z"
        fill="inherit"
      />
    </symbol>
    <symbol id="ic-warning-circle" viewBox="0 0 20 20" fill="none">
      <path
        d="M10.0003 18.3332C14.6027 18.3332 18.3337 14.6022 18.3337 9.99984C18.3337 5.39746 14.6027 1.6665 10.0003 1.6665C5.39795 1.6665 1.66699 5.39746 1.66699 9.99984C1.66699 14.6022 5.39795 18.3332 10.0003 18.3332Z"
        stroke="#EB5757"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10 6.6665V10.4165"
        stroke="#EB5757"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10 13.3237V13.3321"
        stroke="#EB5757"
        stroke-width="1.8"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </symbol>
    <symbol id="ic-quoted-email" viewBox="0 0 18 18">
      <path
        d="M8.09078 14.8181H4.45446C3.65114 14.8181 2.99993 14.1669 2.99994 13.3635L3 4.63643C3 3.83312 3.65121 3.18192 4.45452 3.18192H11C11.8034 3.18192 12.4546 3.83313 12.4546 4.63644V7.54549M5.54558 6.09096H9.90916M5.54558 8.27275H9.90916M5.54558 10.4545H7.72737M11.0259 14.0908L9.54553 12.6034M9.54553 12.6034L10.9589 11.1818M9.54553 12.6034H13.9255C14.519 12.6034 15 12.1224 15 11.529C15 10.9356 14.519 10.4545 13.9255 10.4545H12.4546"
        stroke="currentColor"
        stroke-width="1.3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </symbol>
    <symbol id="ic-pdf-file" viewBox="0 0 100 100">
      <svg
        viewBox="0 0 400 400"
        fill="#ff402f"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          class="cls-1"
          d="M325,105H250a5,5,0,0,1-5-5V25a5,5,0,0,1,10,0V95h70a5,5,0,0,1,0,10Z"
        />
        <path
          class="cls-1"
          d="M325,154.83a5,5,0,0,1-5-5V102.07L247.93,30H100A20,20,0,0,0,80,50v98.17a5,5,0,0,1-10,0V50a30,30,0,0,1,30-30H250a5,5,0,0,1,3.54,1.46l75,75A5,5,0,0,1,330,100v49.83A5,5,0,0,1,325,154.83Z"
        />
        <path
          class="cls-1"
          d="M300,380H100a30,30,0,0,1-30-30V275a5,5,0,0,1,10,0v75a20,20,0,0,0,20,20H300a20,20,0,0,0,20-20V275a5,5,0,0,1,10,0v75A30,30,0,0,1,300,380Z"
        />
        <path
          class="cls-1"
          d="M275,280H125a5,5,0,0,1,0-10H275a5,5,0,0,1,0,10Z"
        />
        <path
          class="cls-1"
          d="M200,330H125a5,5,0,0,1,0-10h75a5,5,0,0,1,0,10Z"
        />
        <path
          class="cls-1"
          d="M325,280H75a30,30,0,0,1-30-30V173.17a30,30,0,0,1,30-30h.2l250,1.66a30.09,30.09,0,0,1,29.81,30V250A30,30,0,0,1,325,280ZM75,153.17a20,20,0,0,0-20,20V250a20,20,0,0,0,20,20H325a20,20,0,0,0,20-20V174.83a20.06,20.06,0,0,0-19.88-20l-250-1.66Z"
        />
        <path
          class="cls-1"
          d="M145,236h-9.61V182.68h21.84q9.34,0,13.85,4.71a16.37,16.37,0,0,1-.37,22.95,17.49,17.49,0,0,1-12.38,4.53H145Zm0-29.37h11.37q4.45,0,6.8-2.19a7.58,7.58,0,0,0,2.34-5.82,8,8,0,0,0-2.17-5.62q-2.17-2.34-7.83-2.34H145Z"
        />
        <path
          class="cls-1"
          d="M183,236V182.68H202.7q10.9,0,17.5,7.71t6.6,19q0,11.33-6.8,18.95T200.55,236Zm9.88-7.85h8a14.36,14.36,0,0,0,10.94-4.84q4.49-4.84,4.49-14.41a21.91,21.91,0,0,0-3.93-13.22,12.22,12.22,0,0,0-10.37-5.41h-9.14Z"
        />
        <path
          class="cls-1"
          d="M245.59,236H235.7V182.68h33.71v8.24H245.59v14.57h18.75v8H245.59Z"
        />
      </svg>
    </symbol>
    <symbol id="ic-word-file" viewBox="0 0 100 100">
      <svg
        viewBox="0 0 400 400"
        fill="#12c8fd"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          class="cls-1"
          d="M325,105H250a5,5,0,0,1-5-5V25a5,5,0,0,1,10,0V95h70a5,5,0,0,1,0,10Z"
        />
        <path
          class="cls-1"
          d="M325,154.83a5,5,0,0,1-5-5V102.07L247.93,30H100A20,20,0,0,0,80,50v98.17a5,5,0,0,1-10,0V50a30,30,0,0,1,30-30H250a5,5,0,0,1,3.54,1.46l75,75A5,5,0,0,1,330,100v49.83A5,5,0,0,1,325,154.83Z"
        />
        <path
          class="cls-1"
          d="M300,380H100a30,30,0,0,1-30-30V275a5,5,0,0,1,10,0v75a20,20,0,0,0,20,20H300a20,20,0,0,0,20-20V275a5,5,0,0,1,10,0v75A30,30,0,0,1,300,380Z"
        />
        <path
          class="cls-1"
          d="M275,280H125a5,5,0,0,1,0-10H275a5,5,0,0,1,0,10Z"
        />
        <path
          class="cls-1"
          d="M200,330H125a5,5,0,0,1,0-10h75a5,5,0,0,1,0,10Z"
        />
        <path
          class="cls-1"
          d="M325,280H75a30,30,0,0,1-30-30V173.17a30,30,0,0,1,30-30h.2l250,1.66a30.09,30.09,0,0,1,29.81,30V250A30,30,0,0,1,325,280ZM75,153.17a20,20,0,0,0-20,20V250a20,20,0,0,0,20,20H325a20,20,0,0,0,20-20V174.83a20.06,20.06,0,0,0-19.88-20l-250-1.66Z"
        />
        <path
          class="cls-1"
          d="M179.67,182.68,165.41,236H155.33l-10.62-39.22L135.06,236h-9.88l-14.57-53.32h10.2l10.31,38.87,9.61-38.87h9.73l10.63,38.87,10.12-38.87Z"
        />
        <path
          class="cls-1"
          d="M199.08,236.82q-8.75,0-13.36-6.29a23.75,23.75,0,0,1-4.61-14.41,21.32,21.32,0,0,1,5.1-14.57,17,17,0,0,1,13.46-5.82,16.75,16.75,0,0,1,13,5.66q5.1,5.66,5.1,14.73,0,9.34-5.29,15A17.54,17.54,0,0,1,199.08,236.82Zm.31-7.34q9,0,9-13.4,0-6.05-2.15-9.55a7.21,7.21,0,0,0-6.6-3.5,7.47,7.47,0,0,0-6.84,3.61q-2.23,3.61-2.23,9.59,0,6.45,2.36,9.84A7.46,7.46,0,0,0,199.39,229.48Z"
        />
        <path
          class="cls-1"
          d="M234.86,236H226V196.55h8V206q1.72-5.51,4.73-8a9.52,9.52,0,0,1,6.17-2.54l1.17,0V205q-6.8,0-9,4.34a18.47,18.47,0,0,0-2.21,8.4Z"
        />
        <path
          class="cls-1"
          d="M284.9,236h-8.32v-8q-3.44,8.79-11.64,8.79a12.43,12.43,0,0,1-11.13-6.05q-3.87-6.05-3.87-15a26.2,26.2,0,0,1,4-14.57,12.86,12.86,0,0,1,11.45-6.21q7.62,0,10.59,7V182.68h8.91ZM276,212.72q0-4.8-2.29-7.48a7.42,7.42,0,0,0-5.92-2.68,7,7,0,0,0-6.17,3.44q-2.23,3.44-2.23,10.27,0,13.2,8.28,13.2a7.58,7.58,0,0,0,5.8-2.83A10.49,10.49,0,0,0,276,219.4Z"
        />
      </svg>
    </symbol>
    <symbol id="ic-excel-file" viewBox="0 0 100 100">
      <svg
        viewBox="0 0 400 400"
        fill="#0f773d"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          class="cls-1"
          d="M325,105H250a5,5,0,0,1-5-5V25a5,5,0,1,1,10,0V95h70a5,5,0,0,1,0,10Z"
        />
        <path
          class="cls-1"
          d="M325,154.83a5,5,0,0,1-5-5V102.07L247.93,30H100A20,20,0,0,0,80,50v98.17a5,5,0,0,1-10,0V50a30,30,0,0,1,30-30H250a5,5,0,0,1,3.54,1.46l75,75A5,5,0,0,1,330,100v49.83A5,5,0,0,1,325,154.83Z"
        />
        <path
          class="cls-1"
          d="M300,380H100a30,30,0,0,1-30-30V275a5,5,0,0,1,10,0v75a20,20,0,0,0,20,20H300a20,20,0,0,0,20-20V275a5,5,0,0,1,10,0v75A30,30,0,0,1,300,380Z"
        />
        <path
          class="cls-1"
          d="M275,280H125a5,5,0,1,1,0-10H275a5,5,0,0,1,0,10Z"
        />
        <path
          class="cls-1"
          d="M200,330H125a5,5,0,1,1,0-10h75a5,5,0,0,1,0,10Z"
        />
        <path
          class="cls-1"
          d="M325,280H75a30,30,0,0,1-30-30V173.17a30,30,0,0,1,30-30h.2l250,1.66a30.09,30.09,0,0,1,29.81,30V250A30,30,0,0,1,325,280ZM75,153.17a20,20,0,0,0-20,20V250a20,20,0,0,0,20,20H325a20,20,0,0,0,20-20V174.83a20.06,20.06,0,0,0-19.88-20l-250-1.66Z"
        />
        <path
          class="cls-1"
          d="M152.44,236H117.79V182.68h34.3v7.93H127.4v14.45h19.84v7.73H127.4v14.92h25Z"
        />
        <path
          class="cls-1"
          d="M190.18,236H180l-8.36-14.37L162.52,236h-7.66L168,215.69l-11.37-19.14h10.2l6.48,11.6,7.38-11.6h7.46L177,213.66Z"
        />
        <path
          class="cls-1"
          d="M217.4,221.51l7.66.78q-1.49,7.42-5.74,11A15.5,15.5,0,0,1,209,236.82q-8.17,0-12.56-6a23.89,23.89,0,0,1-4.39-14.59q0-8.91,4.8-14.73a15.77,15.77,0,0,1,12.81-5.82q12.89,0,15.35,13.59l-7.66,1.05q-1-7.34-7.23-7.34a6.9,6.9,0,0,0-6.58,4,20.66,20.66,0,0,0-2.05,9.59q0,6,2.13,9.22a6.74,6.74,0,0,0,6,3.24Q215.49,229,217.4,221.51Z"
        />
        <path
          class="cls-1"
          d="M257,223.42l8,1.09a16.84,16.84,0,0,1-6.09,8.83,18.13,18.13,0,0,1-11.37,3.48q-8.2,0-13.2-5.51t-5-14.92q0-8.94,5-14.8t13.67-5.86q8.44,0,13,5.78t4.61,14.84l0,1H238.61a22.12,22.12,0,0,0,.76,6.45,8.68,8.68,0,0,0,3,4.22,8.83,8.83,0,0,0,5.66,1.8Q254.67,229.83,257,223.42Zm-.55-11.8a9.92,9.92,0,0,0-2.56-7,8.63,8.63,0,0,0-12.36-.18,11.36,11.36,0,0,0-2.89,7.13Z"
        />
        <path class="cls-1" d="M282.71,236h-8.91V182.68h8.91Z" />
      </svg>
    </symbol>
    <symbol id="ic-ppt-file" viewBox="0 0 100 100">
      <svg
        viewBox="0 0 400 400"
        fill="#fd7a00"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          class="cls-1"
          d="M325,105H250a5,5,0,0,1-5-5V25a5,5,0,1,1,10,0V95h70a5,5,0,0,1,0,10Z"
        />
        <path
          class="cls-1"
          d="M325,154.83a5,5,0,0,1-5-5V102.07L247.93,30H100A20,20,0,0,0,80,50v98.17a5,5,0,0,1-10,0V50a30,30,0,0,1,30-30H250a5,5,0,0,1,3.54,1.46l75,75A5,5,0,0,1,330,100v49.83A5,5,0,0,1,325,154.83Z"
        />
        <path
          class="cls-1"
          d="M300,380H100a30,30,0,0,1-30-30V275a5,5,0,0,1,10,0v75a20,20,0,0,0,20,20H300a20,20,0,0,0,20-20V275a5,5,0,0,1,10,0v75A30,30,0,0,1,300,380Z"
        />
        <path
          class="cls-1"
          d="M275,280H125a5,5,0,1,1,0-10H275a5,5,0,0,1,0,10Z"
        />
        <path
          class="cls-1"
          d="M200,330H125a5,5,0,1,1,0-10h75a5,5,0,0,1,0,10Z"
        />
        <path
          class="cls-1"
          d="M325,280H75a30,30,0,0,1-30-30V173.17a30,30,0,0,1,30-30h.2l250,1.66a30.09,30.09,0,0,1,29.81,30V250A30,30,0,0,1,325,280ZM75,153.17a20,20,0,0,0-20,20V250a20,20,0,0,0,20,20H325a20,20,0,0,0,20-20V174.83a20.06,20.06,0,0,0-19.88-20l-250-1.66Z"
        />
        <path
          class="cls-1"
          d="M157.07,236h-9.61V182.68H169.3q9.34,0,13.85,4.71a16.37,16.37,0,0,1-.37,22.95,17.49,17.49,0,0,1-12.38,4.53H157.07Zm0-29.37h11.37q4.45,0,6.8-2.19a7.58,7.58,0,0,0,2.34-5.82,8,8,0,0,0-2.17-5.62q-2.17-2.34-7.83-2.34H157.07Z"
        />
        <path
          class="cls-1"
          d="M203.95,249.32h-9.06V196.55h8.52v6.88q4.1-7.69,12.07-7.7a12.1,12.1,0,0,1,10.47,5.7q3.91,5.7,3.91,14.57a27.84,27.84,0,0,1-3.73,14.61A12.15,12.15,0,0,1,215,236.82q-7.62,0-11.05-6.33Zm0-29.49A10.23,10.23,0,0,0,206.5,227a7.55,7.55,0,0,0,5.68,2.83,6.57,6.57,0,0,0,6.23-3.73,20.16,20.16,0,0,0,2-9.47,20.91,20.91,0,0,0-2-9.79,6.37,6.37,0,0,0-5.94-3.77,7.5,7.5,0,0,0-6,3.09,12.51,12.51,0,0,0-2.48,8.09Z"
        />
        <path
          class="cls-1"
          d="M256.25,229v7a31.56,31.56,0,0,1-6.17.86,12.57,12.57,0,0,1-6.17-1.43,8.72,8.72,0,0,1-3.77-3.91q-1.19-2.48-1.19-7.64V203.46H234v-6.91h5.43l.82-10.27,7.3-.66v10.94h7.93v6.91h-7.93v19.26q0,3.71,1.35,5.06t5.1,1.35Q255.08,229.13,256.25,229Z"
        />
      </svg>
    </symbol>
    <symbol id="ic-doc-file" viewBox="0 0 100 100">
      <svg
        viewBox="0 0 400 400"
        fill="#101010"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          class="cls-1"
          d="M325,105H250a5,5,0,0,1-5-5V25a5,5,0,0,1,10,0V95h70a5,5,0,0,1,0,10Z"
        />
        <path
          class="cls-1"
          d="M300,380H100a30,30,0,0,1-30-30V50a30,30,0,0,1,30-30H250a5,5,0,0,1,3.54,1.46l75,75A5,5,0,0,1,330,100V350A30,30,0,0,1,300,380ZM100,30A20,20,0,0,0,80,50V350a20,20,0,0,0,20,20H300a20,20,0,0,0,20-20V102.07L247.93,30Z"
        />
        <path
          class="cls-1"
          d="M275,180H125a5,5,0,0,1,0-10H275a5,5,0,0,1,0,10Z"
        />
        <path
          class="cls-1"
          d="M275,230H125a5,5,0,0,1,0-10H275a5,5,0,0,1,0,10Z"
        />
        <path
          class="cls-1"
          d="M275,280H125a5,5,0,0,1,0-10H275a5,5,0,0,1,0,10Z"
        />
        <path
          class="cls-1"
          d="M200,330H125a5,5,0,0,1,0-10h75a5,5,0,0,1,0,10Z"
        />
      </svg>
    </symbol>
  </svg>
</template>

<script>
export default {
  name: "SDKIcon"
};
</script>

<style>
#qiscus-sdk-sprite {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/SVGIcon.vue